var _defs, _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgCoinflipArcs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "fade",
    cx: 0.5,
    cy: 0.5,
    r: 0.65
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#fade)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.18,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-100 400 A500 500 0 0 1 1300 400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 400 A420 420 0 0 1 1200 400",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 400 A340 340 0 0 1 1100 400",
    strokeOpacity: 0.12
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeOpacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 400h20M240 400h20M280 400h20M320 400h20M360 400h20M400 400h20M440 400h20M480 400h20M520 400h20M560 400h20M600 400h20M640 400h20M680 400h20M720 400h20M760 400h20M800 400h20M840 400h20M880 400h20M920 400h20M960 400h20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCoinflipArcs);
export default __webpack_public_path__ + "static/media/bg-coinflip-arcs.c814dd40bd76242b1616044c0e109f9f.svg";
export { ForwardRef as ReactComponent };